import { ITokenAction, SET_TOKEN } from '../actions/AppAction';

interface IAppState {
    token: string;
}

const initialState: IAppState = {
    token: ''
}

export const appReducer = (state = initialState, action: ITokenAction):IAppState => {

    switch (action.type) {

        case SET_TOKEN:

            const newState = {
                token: action.token
            };
            return { ...state, ...newState } 

        default:
            return state;

    }
}